// extracted by mini-css-extract-plugin
export var cardLayout = "_5s-1";
export var paginationContainer = "_5s-0";